import { Component } from '@angular/core';
import { OmpFaqLayout, OmpHeadingAlignment, OmpHeadingSize } from '../../../_models';
import { OmpSectionSettings } from '..';

@Component({
  selector: 'omp-faq-settings',
  templateUrl: './faq-settings.component.html',
  styleUrls: ['../controls/omp-controls.scss'],
})
export class OmpFaqSettingsComponent extends OmpSectionSettings {
  public headingSize = OmpHeadingSize;
  public alignment = OmpHeadingAlignment;
  public faqLayout = OmpFaqLayout;
}
